module.exports = {
	init: function () {
		let screenWidth = window.innerWidth;
		let headerNav = document.querySelector('.header-nav');
		let headerNavWidth = headerNav.offsetWidth;
		let loginMenuItems = document.querySelectorAll('.login-menu .menu-item:not(.header-search)');
		let headerSearch = document.querySelector('.login-menu .menu-item.header-search');
		// Header Search
		function searchChanges(width) {
			// Save original search link markup in a variable
			var ogSearchItem = $('.menu-item.search a');
			var searchLarge = ({ media }) =>
				`<form id="search-form" class="search" action="/search/" method="get" role="search">
					<label for="main-search-field-large${media == 'mobile' ? '-mobile' : '-desktop'}">
						<span class="visually-hidden">Search</span>
						<input id="main-search-field-large${
							media == 'mobile' ? '-mobile' : '-desktop'
						}" type="text" name="fwp_site_search" value="" placeholder="">
					</label>
					<button id="main-search-submit${
						media == 'mobile' ? '-mobile' : '-desktop'
					}" class="submit" form="search-form" type="submit">Search</button>
				</form>
				<button type="button" class="open-search desktop-only">
					<span class="visually-hide-text">Open Search</span>
					<i class="far fa-search"></i>
				</button>`;
			var searchSmall = ({ media }) =>
				'<div class="search-container"><button type="button" class="open-search" data-micromodal-trigger="modal-5"><span class="visually-hide-text">Open Search</span><i class="far fa-search"></i></button></div>';

			// Menu breakpoint
			if (width < 1300) {
				$('.header-search.desktop')
					.html(searchSmall({ media: 'desktop' }))
					.addClass('ready');
				$('.header-search.mobile')
					.html(searchSmall({ media: 'mobile' }))
					.addClass('ready');

				if (headerSearch.classList.contains('active')) {
					headerSearch.classList.remove('active');
					loginMenuItems.forEach((item) => {
						item.classList.remove('hide');
					});
				}
			} else if (width >= 1300) {
				$('.header-search.desktop')
					.html(searchLarge({ media: 'desktop' }))
					.addClass('ready');
				$('.header-search.mobile')
					.html(searchLarge({ media: 'mobile' }))
					.addClass('ready');
			} else {
				// Do nothing
			}
		}

		// Open click event
		$(document).on('click', '.header-nav .header-search .open-search', function (evt) {
			evt.preventDefault();

			let searchForm = document.querySelector('.header-search #search-form');
			let openSearchButton = document.querySelector('.header-search button.open-search');
			let openSearchButtonWidth = openSearchButton.offsetWidth;
			searchForm.style.width = headerNavWidth - openSearchButtonWidth - 15 + 'px';

			if (screenWidth < 1300) {
				console.log('Width smaller than 768px');
				if ($('.modal.is-open').length > 0) {
					MicroModal.close();
				}
				// if mobile, display search modal
				MicroModal.show('modal-5');
			} else if (screenWidth >= 1300) {
				// if desktop, search button displays search in menu
				$('.main-menu').toggleClass('fade');
				$('.header-nav .header-search').toggleClass('active');
				if ($('.header-nav .header-search').hasClass('active')) {
					setTimeout(function (evt) {
						$('.header-nav .header-search input[type="text"]').focus();
					}, 300);
				}
				// If tabbing through, open the search bar
				$('.header-nav .header-search input[type="text"]').on('focus', function (evt) {
					$('.header-nav .header-search').addClass('active');
					$('.top-menu .main-menu').addClass('fade');
				});
				// If tabbing the opposite direction, open the search bar
				$('.header-nav .header-search .close').on('focus', function (evt) {
					$('.header-nav .header-search').addClass('active');
					$('.top-menu .main-menu').addClass('fade');
				});
				// // fade out login menu
				loginMenuItems.forEach((item) => {
					item.classList.toggle('hide');
				});
			}
		});

		// Close search click event
		$(document).on('click', '.header-nav .header-search .close', function (evt) {
			evt.preventDefault();
			$('.header-nav .header-search').toggleClass('active');
			$('.top-menu .main-menu').removeClass('fade');
		});

		function checkWindowSize() {
			screenWidth = window.innerWidth;
			console.log('Screen width: ', screenWidth);
			searchChanges(screenWidth);
		}
		// Run on page load
		checkWindowSize();
		// Listen for page size change
		window.onresize = checkWindowSize;
	},
};
